export default "__VITE_ASSET__3j7buzX4__"